import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';

export const BannerContainer = styled.div`
  &.smallView {
    padding: ${fromTheme('spacing_medium')};
  }

  .actionLink {
    padding: 0;
    text-decoration: underline;
    color: #087db9; // static link color, shouldn't be based on customer config

    &:hover {
      background: transparent;
    }
  }
`;

export const NoResultsInSearchAreaContainer = styled.div`
  display: flex;
  flex-direction: row;
  position: absolute;
  margin: 0 ${fromTheme('spacing_large')};
  top: 77px; // Should this be within the nav bar to prevent his ?
  z-index: 1001;
`;
